import styled, { css } from "styled-components";

export const CataloguePageWrapper = styled.section`
    display: flex;
    gap: 8px;
    padding: 0px;
    height: 100%;
    position: relative;
    width: 100%;
`;

export const CatalogueLeftSectionWrapper = styled.div`
    width: calc(100% - 400px);
    padding: 24px 0px 24px 32px;
    height: 100%;

    @media (max-width: 871px) {
        width: 60%;
    }
    @media (max-width: 767px) {
        width: 100%;
        padding: 24px 0px 24px 16px;
    }
`;

export const HeaderSectionWrap = styled.div`
    display: flex;
    width: 100%;
    gap: 24px;

    @media (max-width: 414px) {
        flex-direction: column;
    }
`;

export const CatalogueGridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px 20px;
    margin-top: 40px;

    @media (max-width: 1165px) {
        grid-template-columns: repeat(2, 1fr);
    }
    /* @media (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    } */
`;

export const ItemCardStyled = styled.div`
    border-radius: 5px;
    border: 1px solid #f4f4f4;
    background: #fff;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.06);
    padding: 20px 16px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: pointer;

    ${({ selectedStyle }) =>
        selectedStyle &&
        css`
            opacity: 0.6;
            cursor: not-allowed;
        `}
    h4 {
        color: #000;
        font-size: 1.063rem;
        font-weight: 900;
        line-height: 20px;
    }
    p {
        color: #979797;
        margin-top: 4px;
        font-weight: 400;
        line-height: normal;
        font-size: 0.938rem;
    }
`;

export const CatalogueRightSideWrapper = styled.section`
    width: 390px;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(219, 220, 224, 0.8);
    background: #fff;
    padding: 32px 0px 40px;
    height: 100%;
    position: relative;

    @media (max-width: 871px) {
        width: 38%;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

export const OrderTopSectopmWrap = styled.div`
    padding: 0px 24px 20px;
    border-bottom: 1px solid rgba(219, 220, 224, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    position: relative;
    h3 {
        color: #000;
        font-size: 1.5rem;
        font-weight: 900;
        line-height: 30px;
    }
    p {
        color: #979797;
        margin-top: 6px;
    }
    .sales__order-clear-link {
        color: #f7685b;
        font-size: 0.938rem;
        font-weight: 800;
        line-height: normal;
        text-decoration-line: underline;
        margin-top: 0px;
        cursor: pointer;
    }
    .sales__order-clear-link-loading {
        color: #f7685b;
        font-size: 0.938rem;
        font-weight: 800;
        line-height: normal;
    }
    .sales__order-history-close {
        position: absolute;
        top: 0px;
        right: 16px;
        cursor: pointer;
    }
`;

export const MobileOrderDetailsWrap = styled.div`
    background: #f9f9f9;
    width: 100%;
    padding: 24px 0px 24px;

    .sales__order-mobile-top-wrap {
        margin-bottom: 24px;
        padding-left: 24px;
    }

    @media (min-width: 768px) {
        display: none;
    }
`;

export const EmptyAddedItemsWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    /* padding: 20px; */
    .sales__empty-icon-wrap {
        width: 160px;
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #f4f4f4;
    }
`;

export const TotalChargeWrapper = styled.div`
    border-top: 1px solid rgba(219, 220, 224, 0.8);
    padding: 16px 24px 40px;
    width: 100%;
    background: #fff;
    position: absolute;
    bottom: 0px;
    padding: ${({ fromOrderHistory }) => (fromOrderHistory ? "16px 24px 70px" : "16px 24px 40px")};
    .sales__sub-total-item-wrap {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-bottom: 16px;

        .sales__total-amout {
            color: #979797;
        }
        .sales__sum-total-amount {
            color: #000;
        }
    }
    .sales__total-item-wrap {
        margin-bottom: 0px;
        margin-top: 22.5px;

        h4 {
            color: #979797;
        }
    }
    .sales__pay-buttons-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
        gap: 12px;
        margin-top: 38.5px;
    }
`;

export const AddedItemsWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 0px;
    :first-child {
        padding-top: 4px;
    }
    :not(:last-child) {
        border-bottom: 1px solid rgba(219, 220, 224, 0.5);
    }
    .sales__order-item-wrap {
        p {
            color: #979797;
            margin-top: 6px;
        }
    }
`;

export const IncrementButtonWrap = styled.div`
    display: flex;
    border-radius: 40px;
    background: #f6f6f6;
    padding: 8px;
    align-items: center;
    gap: 16px;

    .sales__order-icon {
        cursor: pointer;
    }
`;

export const ChargeButtonWrapper = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0px;
    border-top: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    padding: 24px 16px;
    display: block;

    @media (min-width: 768px) {
        display: none;
    }
`;

export const CatalogueSyncWrapper = styled.div`
    width: 100%;
    border: 1px solid #fff5db;
    background: #fff5db;
    padding: 16px 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 24px;
    margin-top: -24px;
    width: calc(100% + 42px);
    margin-left: -32px;
    margin-right: -10px;
    p {
        color: #000;
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }

    @media (max-width: 767px) {
        margin-right: 0px;
        width: calc(100% + 32px);
    }
`;

export const EmptyItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    max-width: 100%;
    padding: 124px 20px 20px;
    gap: 32px;
    margin: 0 auto;
    h3 {
        text-align: center;
    }
    p {
        text-align: center;
        margin-top: 12px;
    }
`;
